/**
 * Typed access to the WebAuthn Level 3 JSON convenience methods
 * (`PublicKeyCredential.parseCreationOptionsFromJSON`, `.parseRequestOptionsFromJSON`,
 * and `credential.toJSON()`). Browsers have supported these for a while (Chrome 116+,
 * Safari 17.4+, Firefox 119+), but the TypeScript version pinned here (5.6) doesn't
 * declare them yet, and — because the DOM lib declares `PublicKeyCredential`'s static
 * side as an anonymous object type rather than a named interface — they can't be added
 * by ordinary declaration merging. Delete this file's casts once `lib.dom.d.ts` catches up.
 */

interface CredentialsJsonStatics {
  parseCreationOptionsFromJSON(options: unknown): PublicKeyCredentialCreationOptions;
  parseRequestOptionsFromJSON(options: unknown): PublicKeyCredentialRequestOptions;
}

const jsonStatics = PublicKeyCredential as unknown as CredentialsJsonStatics;

export const parseCreationOptionsFromJSON = (
  options: unknown
): PublicKeyCredentialCreationOptions => jsonStatics.parseCreationOptionsFromJSON(options);

export const parseRequestOptionsFromJSON = (
  options: unknown
): PublicKeyCredentialRequestOptions => jsonStatics.parseRequestOptionsFromJSON(options);

export const credentialToJSON = (credential: PublicKeyCredential): unknown =>
  (credential as unknown as { toJSON(): unknown }).toJSON();
